import React from 'react';

const ReadAPIStatus = () => {
    return (

        <div>
            
            <div style={{ height: 10 }}></div>

            <img src={"https://healthchecks.io/badge/9eb09fbb-348a-4316-ba4d-c2e543/z-XVoCmN-2/search-function.svg"} />

            <br />

            <div style={{ height: 10 }}></div>

            <img src={"https://healthchecks.io/badge/9eb09fbb-348a-4316-ba4d-c2e543/e0lWy4vv-2/question-generator.svg"} />

        </div>

    );
}

export default ReadAPIStatus;